import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { createStyles, makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) =>
    createStyles({
        o: {},
        "@global": {
            ".css-1kpdewa-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
                {
                    padding: "0px 4px 0px 6px !important",
                },
        },
    })
);

export default function AutoCompleteHotel(props: {
    id?: string;
    name: string;
    values: any;
    selectedValues: any;
    onChangeSelect: (v: any) => void;
    isUpdating?: boolean;
    isNotOutlined?: boolean;
}) {
    let isReadOnlyDefaultValue: boolean = props.isUpdating || false;
    const handleChangeOption = (event: any, newValue: any) => {
        props.onChangeSelect(newValue);
    };
    const classes = styles();
    return (
        <Stack spacing={3}>
            <Autocomplete
                id={props.id ? props.id : "idAutoCompleteWithChips"}
                options={props.values}
                getOptionLabel={(option) => (option.name ? option.label : "")}
                onChange={handleChangeOption}
                value={props.selectedValues}
                disabled={isReadOnlyDefaultValue}
                className={classes.o}
                renderInput={(params) => <TextField {...params} />}
            />
        </Stack>
    );
}
